const coins = [
    {
        id: '1',
        name: 'bitcoin',
        symbol: 'BTC',
        trade: 'BTCUSD',
        usd: 28348,
        usd_24h_change: 1.5321285763972192
    },
    {
        id: '2',
        name: 'ethereum',
        symbol: 'ETH',
        trade: 'ETHUSD',
        usd: 1861.38,
        usd_24h_change: 1.4484656830159377
    },
    {
        id: '3',
        name: 'uniswap',
        symbol: 'UNI',
        trade: 'UNIUSD',
        usd: 5.87,
        usd_24h_change: 0.46343684149149605
    },
    {
        id: '4',
        name: 'litecoin',
        symbol: 'LTC',
        trade: 'LTCUSD',
        usd: 90.64,
        usd_24h_change: 0.6260265072004563
    },
    {
        id: '5',
        name: 'Ripple',
        symbol: 'XRP',
        trade: 'XRPUSD',
        usd: 0.506453,
        usd_24h_change: 0.6260265072004563
    },
    {
        id: '5',
        name: 'Polygon',
        symbol: 'MATIC',
        trade: 'MATICUSD',
        usd: 0.506453,
        usd_24h_change: -0.09269603161592051
    },
    {
        id: '6',
        name: 'Cardano',
        symbol: 'XLM',
        trade: 'XLMUSD',
        usd: 0.388373,
        usd_24h_change: 1.5321285763972192
    },

];

export default coins;
